<template>
    <div class="table__body">
        <div class="table__row" v-for="customer in customers">
            <div class="table__col" v-for="item in customer">
                {{item}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['customers'],
    }
</script>
<style lang="sass">
    .table
        &__body
            max-height: 450px
            overflow-y: auto
            scrollbar-width: none
            &::-webkit-scrollbar
                width: 0
                background: $color--gray
                scrollbar-width: none
                display: none
            &::-moz-scrollbar,
            &::-o-scrollbar
                display: none
                scrollbar-width: none
            &::-webkit-scrollbar-track,
            &::-webkit-scrollbar-thumb
                background-color: $color--gray
                -ms-overflow-style: none
                scrollbar-width: none
                display: none
        &__row
            display: flex
            align-items: center
            border-bottom: 1px solid $border--color-gray
            &:first-of-type
                border-top: 1px solid $border--color-gray
            &:nth-child(even)
                background: rgba($color--blue, 0.03)
        &__col
            padding: 16px 0
            flex: 1
            &:first-of-type
                padding-left: 8px
                flex: 0 0 80px
</style>